import { Group, noop } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"
import { SearchInput } from "@tfg/ui"
import { ChangeEvent } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  search: string
  onChange: (search: string | ChangeEvent<HTMLInputElement>) => void
}

export const SearchBox = ({ search, onChange }: Props) => {
  const { t } = useTranslation("organizationSettings")

  return (
    <Group justify="flex-end" mt="var(--tfg-organism-padding-y)">
      <SearchInput
        w="20%"
        inputValue={search ?? ""}
        onChange={onChange}
        onOpen={noop}
        leftSection={<IconSearch size={16} />}
        placeholder={t("mapping.search")}
      />
    </Group>
  )
}
